import React, { Reducer, useEffect, useState } from 'react'
import './App.css'
import { useReducer } from 'react'
import Piece from './Piece';
import { Board, action, mainState, move, moveOption, piece, pieceKind, pieceState, piecesState, playState, pos, state } from './types';

const promotablePieces: pieceKind[] = ['ma','aa','ku','th']

window.addEventListener('error', e => {
  const text = JSON.stringify(window.game);
  const blob = new Blob([text], {type: 'application/json'});
  const uri = URL.createObjectURL(blob);
  
  document.body.innerHTML = '';
  const errorInfo = document.body.appendChild(document.createElement('h2'))
  errorInfo.append('Oops, Something went wrong!', document.createElement('br'), 'History of this game can be found ')

  const anchor = errorInfo.appendChild(document.createElement('a'));
  anchor.innerText = "here"
  anchor.href = uri;
  anchor.download = "gameHistory.json";
})

const BOARD: Board = [];
for(let i=0; i<8; i++) {
    BOARD.push([]);
    for(let j=0; j<8; j++)
        BOARD[i].push(0);
}

const checkBox = (state: playState, x: number, y: number) => {
  if(x>7 || y>7 || x<0 || y<0) {
    return -1;
  }
  const ps = state.pieces.find(i => i.pos.x===x && i.pos.y===y && !i.killed);
  if(!ps) return 1;
  else return ps.piece;
}

function checkDir (state: playState, pos: pos, x: -1 | 0 | 1, y: -1 | 0 | 1) {
  for(let i=1; i<8; i++) {
    const item = checkBox(state, pos.x+x*i, pos.y+y*i);
    if(item===1) continue;
    else if(item===-1) return -1;
    else return {piece: item, pos: {x: i*x, y: i*y}};
  }
  return -1;
}

const isChecked = (state: playState, isCheckingBlack: boolean) => {
  const king = state.pieces.find(i => i.piece.kind==='ra' && i.piece.black===isCheckingBlack)!;
  const otherPlayerDir = state.isTopBlack===isCheckingBlack?-1:1;

  let _p: pieceState | 1 | -1;
  // check diagonally, -1,-1/
  _p = checkDir(state, king.pos, -1, -1);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.x===-1 && (_p.piece.kind==='ra' || (_p.piece.kind==='ka' && otherPlayerDir===1)))
      || _p.piece.kind==='ma' || _p.piece.kind==='aa'
    )
  ) return true;
  _p = checkDir(state, king.pos, -1, 1);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.x===-1 && (_p.piece.kind==='ra' || (_p.piece.kind==='ka' && otherPlayerDir===-1)))
      || _p.piece.kind==='ma' || _p.piece.kind==='aa'
    )
  ) return true;
  _p = checkDir(state, king.pos, 1, -1);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.x===1 && (_p.piece.kind==='ra' || (_p.piece.kind==='ka' && otherPlayerDir===1)))
      || _p.piece.kind==='ma' || _p.piece.kind==='aa'
    )
  ) return true;
  _p = checkDir(state, king.pos, 1, 1);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.x===1 && (_p.piece.kind==='ra' || (_p.piece.kind==='ka' && otherPlayerDir===-1)))
      || _p.piece.kind==='ma' || _p.piece.kind==='aa'
    )
  ) return true;


  _p = checkDir(state, king.pos, 0, 1);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.y===1 && _p.piece.kind==='ra')
      || _p.piece.kind==='ma' || _p.piece.kind==='th'
    )
  ) return true;
  _p = checkDir(state, king.pos, 0, -1);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.y===-1 && _p.piece.kind==='ra')
      || _p.piece.kind==='ma' || _p.piece.kind==='th'
    )
  ) return true;
  _p = checkDir(state, king.pos, 1, 0);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.x===1 && _p.piece.kind==='ra')
      || _p.piece.kind==='ma' || _p.piece.kind==='th'
    )
  ) return true;
  _p = checkDir(state, king.pos, -1, 0);
  if(typeof _p === 'object' && _p.piece.black!==isCheckingBlack
    && (
      (_p.pos.x===-1 && _p.piece.kind==='ra')
      || _p.piece.kind==='ma' || _p.piece.kind==='th'
    )
  ) return true;

  let _p1: -1 | 1 | piece = checkBox(state, king.pos.x-2, king.pos.y-1)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
  _p1 = checkBox(state, king.pos.x-2, king.pos.y+1)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
  _p1 = checkBox(state, king.pos.x+2, king.pos.y-1)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
  _p1 = checkBox(state, king.pos.x+2, king.pos.y+1)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
  
  _p1 = checkBox(state, king.pos.x-1, king.pos.y-2)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
  _p1 = checkBox(state, king.pos.x-1, king.pos.y+2)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
  _p1 = checkBox(state, king.pos.x+1, king.pos.y-2)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
  _p1 = checkBox(state, king.pos.x+1, king.pos.y+2)
  if(typeof _p1 === 'object' && _p1.black!==isCheckingBlack && _p1.kind==='ku') return true;
}

function makeMove(oldState: playState, pieceAt: pos, move: move) {
  /*
  case kill:
    mark target piece as killed, change its pos to -1,-1
  case castle:
    move ther piece on the castling side accordingly
  case pawn promotion:
    change piece kind to promoted kind
  change piece pos to move pos
  */
  const newState = {...oldState, pieces: [...oldState.pieces]};
  switch(move.type) {
    case 'kill':
      const killPos = move.targetPiece.pos || move;
      const pki = newState.pieces.findIndex(i => i.pos.x===killPos.x && i.pos.y===killPos.y);
      newState.pieces[pki] = {...newState.pieces[pki], moved: true, killed: true, pos: {x: -1, y: -1}};
      break;
    case 'castle':
      const thInd = newState.pieces.findIndex(i => i.pos.x===(pieceAt.x<move.x?7:0) && i.pos.y===pieceAt.y);
      newState.pieces[thInd] = {...newState.pieces[thInd], moved: true, pos: {x: move.x<4?move.x+1:move.x-1, y: move.y}};
      break;
  }
  const pi = newState.pieces.findIndex(i => i.pos.x===pieceAt.x && i.pos.y===pieceAt.y);
  newState.pre = [newState.pieces[pi].pos, {x: move.x, y: move.y}];
  newState.pieces[pi] = {
    ...newState.pieces[pi],
    moved: true,
    pos: {x: move.x, y: move.y},
    piece: {
      black: newState.pieces[pi].piece.black,
      kind: move.type!=='castle' && move.promotion
        ?move.promotion
        :newState.pieces[pi].piece.kind
    },
  };
  return newState;
}

function findMoves(state: state, ps: pieceState) {
  if(!ps) return [];
  const moves: moveOption[] = [];
  const checkAndAdd = (x: number, y: number, requiredToAdd:(1|2)[], isRa?: true) => {
    let status:1|2;
    // -1: out of board
    // 0: same team piece there
    // 1: empty space
    // 2: enemy team piece there
    // 3: piece to check is the king himself, and target is controlled by enemy
    
    // status is still 1 or 2 if move will result in self check, but will not be added to moves
    const tps = checkBox(state, x, y);
    if(tps===-1) return tps;
    else if(tps===1) status=1;
    else if(tps.black!==ps.piece.black) status=2;
    else return 0;

    const move: move = status===2 && typeof tps==='object'?{
      x, y, type: 'kill',
      targetPiece: {piece: {kind: tps.kind, black: tps.black}, pos: {x,y}}
    }:{x, y, type: 'simple'};

    const newState = makeMove(state, ps.pos, move);
    if(isChecked(newState, ps.piece.black)) return isRa?3:status;

    if(requiredToAdd.includes(status))
      moves.push({...move, promotion: ps.piece.kind==='ka' && (y===0 || y===7)});
    return status;
  }
  let temp: pos, tempPiece: pieceState | undefined, fromTop: boolean;
  switch(ps.piece.kind) {
    case 'aa':
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x+i, ps.pos.y+i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x+i, ps.pos.y-i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x-i, ps.pos.y+i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x-i, ps.pos.y-i, [1,2])!==1)
          break;
      break;
    case 'th':
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x+i, ps.pos.y, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x-i, ps.pos.y, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x, ps.pos.y+i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x, ps.pos.y-i, [1,2])!==1)
          break;
      break;
    case 'ma':
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x+i, ps.pos.y+i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x+i, ps.pos.y-i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x-i, ps.pos.y+i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x-i, ps.pos.y-i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x+i, ps.pos.y, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x-i, ps.pos.y, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x, ps.pos.y+i, [1,2])!==1)
          break;
      for(let i=1; i<8; i++)
        if(checkAndAdd(ps.pos.x, ps.pos.y-i, [1,2])!==1)
          break;
      break;
    case 'ra':
      checkAndAdd(ps.pos.x+1, ps.pos.y+1, [1,2], true);
      checkAndAdd(ps.pos.x+1, ps.pos.y-1, [1,2], true);
      checkAndAdd(ps.pos.x-1, ps.pos.y+1, [1,2], true);
      checkAndAdd(ps.pos.x-1, ps.pos.y-1, [1,2], true);
      const kingRight = checkAndAdd(ps.pos.x+1, ps.pos.y, [1,2], true);
      const kingLeft = checkAndAdd(ps.pos.x-1, ps.pos.y, [1,2], true);
      checkAndAdd(ps.pos.x, ps.pos.y+1, [1,2], true);
      checkAndAdd(ps.pos.x, ps.pos.y-1, [1,2], true);

      if(!ps.moved) {
        if(kingRight===1 && checkBox(state, ps.pos.x+2, ps.pos.y)===1 && (ps.pos.x===4 || checkBox(state, 6, ps.pos.y)===1)) {
          const therPiece = state.pieces.find(i => i.pos.x===7 && i.pos.y===ps.pos.y && i.piece.black===ps.piece.black)
          if(therPiece && !therPiece.moved) {
            const move: move = {x: ps.pos.x+2, y: ps.pos.y, type: 'castle'};
            const newState = makeMove(state, ps.pos, move);
            if(!isChecked(newState, ps.piece.black)) moves.push(move);
          }
        }
        if(kingLeft===1 && checkBox(state, ps.pos.x-2, ps.pos.y)===1 && (ps.pos.x===3 || checkBox(state, 1, ps.pos.y)===1)) {
          const therPiece = state.pieces.find(i => i.pos.x===0 && i.pos.y===ps.pos.y && i.piece.black===ps.piece.black)
          if(therPiece && !therPiece.moved){
            const move: move = {x: ps.pos.x-2, y: ps.pos.y, type: 'castle'};
            const newState = makeMove(state, ps.pos, move);
            if(!isChecked(newState, ps.piece.black)) moves.push(move);
          }
        }
      }
      break;
    case 'ka':
      fromTop = state.isTopBlack===ps.piece.black;
      const a = checkAndAdd(ps.pos.x, ps.pos.y+(fromTop?1:-1), [1])
      if(ps.pos.y===(fromTop?1:6) && a===1)
        checkAndAdd(ps.pos.x, ps.pos.y+(fromTop?2:-2), [1])
      const kaCutRight = checkAndAdd(ps.pos.x+1, ps.pos.y+(fromTop?1:-1), [2])
      const kaCutLeft = checkAndAdd(ps.pos.x-1, ps.pos.y+(fromTop?1:-1), [2])

      // check if not killing in right direction
      // check if right adjacent is pre move
      // check if right adjacent is enemy ka
      // check if pre move is two squares
      // do same for left
      if(
        kaCutRight===1
        && state.pre
        && state.pre[1].x===ps.pos.x+1
        && state.pre[1].y===ps.pos.y
      ) {
        const lastPieceInd = state.pieces.findIndex(i => state.pre && i.pos.x===state.pre[1].x && i.pos.y===state.pre[1].y)
        const lastPiece = state.pieces[lastPieceInd];
        if(
          lastPiece
          && lastPiece.piece.black!==ps.piece.black
          && lastPiece.piece.kind==='ka'
          && Math.abs(state.pre[1].y-state.pre[0].y)===2
        ) {
          const move: move = {
            x: ps.pos.x+1,
            y: ps.pos.y+(fromTop?1:-1),
            type: 'kill',
            targetPiece: {...lastPiece},
          };
          const newState = makeMove(state, ps.pos, move)
          if(!isChecked(newState, ps.piece.black)) {
            console.log('pushing')
            moves.push({...move, promotion: (ps.pos.y===6&&fromTop) || (ps.pos.y===1&&!fromTop)});
          }
        }
      }
      if(
        kaCutLeft===1
        && state.pre
        && state.pre[1].x===ps.pos.x-1
        && state.pre[1].y===ps.pos.y
      ) {
        const lastPieceInd = state.pieces.findIndex(i => state.pre && i.pos.x===state.pre[1].x && i.pos.y===state.pre[1].y)
        const lastPiece = state.pieces[lastPieceInd];
        if(
          lastPiece
          && lastPiece.piece.black!==ps.piece.black
          && lastPiece.piece.kind==='ka'
          && Math.abs(state.pre[1].y-state.pre[0].y)===2
        ) {
          const move: move = {
            x: ps.pos.x-1,
            y: ps.pos.y+(fromTop?1:-1),
            type: 'kill',
            targetPiece: {...lastPiece},
          };
          const newState = makeMove(state, ps.pos, move)
          if(!isChecked(newState, ps.piece.black)) {
            moves.push({...move, promotion: (ps.pos.y===6&&fromTop) || (ps.pos.y===1&&!fromTop)})
          }
        }
      }
      break;
    case 'ku':
      checkAndAdd(ps.pos.x+2, ps.pos.y+1, [1,2]);
      checkAndAdd(ps.pos.x+2, ps.pos.y-1, [1,2]);
      checkAndAdd(ps.pos.x-2, ps.pos.y+1, [1,2]);
      checkAndAdd(ps.pos.x-2, ps.pos.y-1, [1,2]);

      checkAndAdd(ps.pos.x+1, ps.pos.y+2, [1,2]);
      checkAndAdd(ps.pos.x-1, ps.pos.y+2, [1,2]);
      checkAndAdd(ps.pos.x+1, ps.pos.y-2, [1,2]);
      checkAndAdd(ps.pos.x-1, ps.pos.y-2, [1,2]);
      break;
  }
  return moves;
}

function findEndings(state: state) {
  let movesForPlayer: boolean = false;
  for(const piece of state.pieces) {
    if(piece.killed) continue;
    if(piece.piece.black!==state.isPlayerBlack) {
      if(state.checked)
        continue;
      const moves = findMoves(state, piece)
      if(moves.find(i => i.type==='kill' && i.targetPiece.piece.kind==='ra'))
        state.checked = true;
    } else {
      if(movesForPlayer)
        continue;
      if(findMoves(state, piece).length)
        movesForPlayer = true;
    }
    if(movesForPlayer && state.checked) return;
  }
  if(!movesForPlayer && state.checked) state.ended = 'checkmate';
  else if(!movesForPlayer && !state.checked) state.ended = 'stalemate';
}

function makePieces(isTopBlack: boolean) {
  const o: pieceKind[] = ['th', 'ku', 'aa', 'ra', 'ma', 'aa', 'ku', 'th'];
  const pieces: piecesState = [];
  for(let ii=0; ii<8; ii++) {
    const i = o[ii];
    pieces.push({piece: {kind: i, black: isTopBlack}, pos: {x: ii, y: 0}})
    pieces.push({piece: {kind: i, black: !isTopBlack}, pos: {x: ii, y: 7}})
  }
  for(let i=0; i<8; i++) {
    pieces.push({piece: {kind: 'ka', black: isTopBlack}, pos: {x: i, y: 1}});
    pieces.push({piece: {kind: 'ka', black: !isTopBlack}, pos: {x: i, y: 6}});
  }
  return pieces;
}

export default function Game({state, changeState}: {state: mainState, changeState: (state: mainState) => void}) {
  const [game, dispatch] = useReducer<Reducer<state, action>>(function(state, action) {
    let preMove: {from: pos, to: pos, killed?: piece};
    switch(action.type) {
      case 'init':
        return {
          board: BOARD,
          pieces: makePieces(action.isTopBlack),
          isTopBlack: action.isTopBlack,
          isPlayerBlack: false,
          disabled: false,
          checked: false,
          progress: {
            isTopBlack: action.isTopBlack,
            moves: [],
            inHistory: 0,
          },
        }
      // case 'reinit':
      //   return {
      //     board: BOARD,
      //     pieces: makePieces(action.history.isTopBlack),
      //     isTopBlack: action.history.isTopBlack,
      //     isPlayerBlack: false,
      //     disabled: true,
      //     checked: false,
      //     progress: {
      //       ...action.history,
      //       inHistory: action.history.moves.length,
      //     },
      //   }
      case 'toggleAbility':
        return {...state, disabled: !state.disabled}
      case 'select':
        state = {...state, selected: action.piece.pos};
        state.nexts = findMoves(state, action.piece);
        return state;
      case 'selectpromotion':
        return {...state, selectPromotion: action.target};
      case 'move':
        const ps = state.selected;
        if(ps===undefined) return state;
        
        state = {
          ...makeMove(state, ps, action.target),
          // pieces: [...state.pieces],
          selected: undefined,
          isPlayerBlack: !state.isPlayerBlack,
          nexts: undefined,
          // isTopBlack: state.isTopBlack,
          disabled: false,
          checked: false,
          selectPromotion: false,
          // pre: [{x: ps.x, y: ps.y}, {x: action.target.x, y: action.target.y}],
          progress: {
            ...state.progress,
            moves: [...state.progress.moves],
          },
        };
        if(state.progress.inHistory) {
          state.progress.moves.splice(state.progress.moves.length - state.progress.inHistory - 1, state.progress.inHistory);
          state.progress.inHistory = 0;
        }
        state.progress.moves.push({from: {x: ps.x, y: ps.y}, move: action.target});
        
        findEndings(state);
        return state;
      // case 'unmove':
      //   state = {
      //     pieces: [...state.pieces],
      //     selected: undefined,
      //     isPlayerBlack: !state.isPlayerBlack,
      //     nexts: undefined,
      //     isTopBlack: state.isTopBlack,
      //     disabled: false,
      //     checked: false,
      //     progress: {
      //       ...state.progress,
      //       inHistory: state.progress.inHistory+1,
      //     },
      //   };
      //   preMove = state.progress.moves[state.progress.moves.length-state.progress.inHistory-1];
      //   if(preMove) state.pre = [preMove.from, preMove.to];
      //   const undoingMove = state.progress.moves[state.progress.moves.length-state.progress.inHistory];
      //   if(undoingMove.killed) {
      //     const lkp = state.pieces.findIndex(i => i.killed && i.piece.black===undoingMove.killed?.black && i.piece.kind===undoingMove.killed?.kind)
      //     state.pieces[lkp] = {piece: state.pieces[lkp].piece, pos: {x: undoingMove.to.x, y: undoingMove.to.y}};
      //   }
      //   // TODO add castling reverser && pawn promotion changer
      //   const lp = state.pieces.findIndex(i => i.pos.x===undoingMove.to.x && i.pos.y===undoingMove.to.y && !i.killed)
      //   state.pieces[lp] = {piece: state.pieces[lp].piece, pos: {x: undoingMove.from.x, y: undoingMove.from.y}};

      //   findEndings(state);
      //   return state;
      // case 'remove':
      //   preMove = state.progress.moves[state.progress.moves.length-state.progress.inHistory];
      //   state = {
      //     pieces: [...state.pieces],
      //     selected: undefined,
      //     isPlayerBlack: !state.isPlayerBlack,
      //     nexts: undefined,
      //     isTopBlack: state.isTopBlack,
      //     disabled: false,
      //     checked: false,
      //     pre: [preMove.from, preMove.to],
      //     progress: {
      //       ...state.progress,
      //       inHistory: state.progress.inHistory-1,
      //     },
      //   };
      //   const nextMove = state.progress.moves[state.progress.moves.length-state.progress.inHistory];
      //   if(nextMove.killed) {
      //     const nkp = state.pieces.findIndex(i => !i.killed && i.pos.x===nextMove.to.x && i.pos.y===nextMove.to.y);
      //     state.pieces[nkp] = {piece: state.pieces[nkp].piece, pos: {x: -1, y: -1}, killed: true};
      //   }
      //   // TODO add castling reverser && pawn promotion changer
      //   const np = state.pieces.findIndex(i => i.pos.x===nextMove.from.x && i.pos.y===nextMove.from.y && !i.killed)
      //   state.pieces[np] = {piece: state.pieces[np].piece, pos: {x: nextMove.to.x, y: nextMove.to.y}};

      //   findEndings(state);
      //   return state;
      case 'draw':
        return {...state, disabled: true, ended: 'draw'};
      default:
        return state;
    }
  }, {pieces: [], progress: {isTopBlack: true, moves: [], inHistory: 0}, isTopBlack: false, isPlayerBlack: false, disabled: true, checked: false});
  useEffect(() => {
    if(state.state==='play')
      dispatch({type: 'init', isTopBlack: state.isTopBlack});
    // else if(state.state==='replay')
      // dispatch({type: 'reinit', history: state.history});
    else if(state.state==='draw')
      dispatch({type: 'draw'});
  }, [state])
  useEffect(() => {
    window.game = game.progress;
  }, [game.progress])
  useEffect(() => {
    if(state.state==='play') {
      changeState({state: 'playing'});
      dispatch({type: 'init', isTopBlack: state.isTopBlack});
    } else if(state.state==='playing' && game.ended==='checkmate') {
      changeState({state: 'checkmate', isWinnerBlack: !game.isPlayerBlack});
    } else if(state.state==='playing' && game.ended==='stalemate') {
      changeState({state: 'stalemate'})
    } else if(state.state==='draw' && !game.ended) {
      dispatch({type: 'draw'});
    }
  }, [state, game])
  useEffect(() => {
    const listener = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    }
    window.addEventListener('beforeunload', listener)
    return () => window.removeEventListener('beforeunload', listener);
  }, [])
  return (
    <div className="game">
      <div className="board">
        {BOARD.map((row, i) => (
          <div key={i} className="row">
            {row.map((_, j) => (
              <div key={i+''+j} className={
                "square "
                +((i+j)%2?"black ":"white ")
              }>
                {game.pre && ((game.pre[0].x===j && game.pre[0].y===i) || (game.pre[1].x===j && game.pre[1].y===i))?<div className="previous" />:null}
                {game.selected?.x===j && game.selected?.y===i?<div className="selected" />:null}
                {game.nexts?.find(k => k.x===j && k.y===i)?<div className="movesquare" />:null}
              </div>
            ))}
          </div>
        ))}
      </div>
      {game.pieces.map((i,ii) => i.killed?null:(
        <div key={ii} onClick={() => dispatch({type: 'select', piece: i})} className={"piece "+(game.isPlayerBlack!==i.piece.black || game.disabled?"disabled ":"")} style={{top: i.pos.y*4+'em', left: i.pos.x*4+'em'}}>
          {game.checked && i.piece.black===game.isPlayerBlack && i.piece.kind==='ra'?(
            <div className='check' />
          ):null}
          <Piece kind={i.piece.kind} black={i.piece.black} />
        </div>
      ))}
      {game.nexts?.map((i,ii) => (
        <div key={ii} onClick={() => i.type!=='castle' && i.promotion===true?dispatch({type: 'selectpromotion', target: {...i, promotion: true}}):dispatch({type: 'move', target: i.type==='castle'?i:{...i, promotion: undefined}})} className={'move '+(i.type==='kill'?'kill':'')} style={{top: i.y*4+'em', left: i.x*4+'em'}} />
      ))}
      {game.selectPromotion?
        <div className="overlay">
          <div className="overlay-body">
            <h4>Which one would you like?</h4>
            <div className="overlay-list">
              {promotablePieces.map(i => (
                <img key={i} onClick={() => game.selectPromotion?dispatch({type: 'move', target: {...game.selectPromotion, promotion: i}}):null} className="overlay-list-item" src={require('./assets/'+i+'-'+(game.isPlayerBlack?'b':'w')+'.png')} />
              ))}
            </div>
          </div>
        </div>
      :null}
      <div style={{position: 'absolute', bottom: '-1.2em', fontSize: '0.7em', color: 'white'}}>{
        state.state==='checkmate'
          ? 'Checkmate! '+(state.isWinnerBlack?'Black':'White')+' won!'
          :state.state==='draw'
            ? 'Draw'
            :state.state==='stalemate'
              ?'Stalemate!'
              :state.state==='playing'
                ? (game.isPlayerBlack?'Black\'s play':'White\'s play')+(game.checked?', Check':'')
                : ''
      }</div>
    </div>
  )
}